import { GeoJSON } from 'ol/format'
import proj4 from 'proj4';

// import { default as JSZip } from 'jszip';
// import JSZip from 'https://cdn.jsdelivr.net/npm/jszip-sync@3.2.1-sync/+esm'
import { default as JSZip } from 'jszip-sync';

const zip = new JSZip();

function shp2geojson(buffer) {
  let shpData, dbfString, dbfData, prjString, geojson;

  zip.sync(() => {
    zip.loadAsync(buffer).then(zip => {});
    const shpFile = zip.file(/.shp$/i)[0];
    if (shpFile) shpFile.async('arraybuffer').then(result => shpData = result);
    const dbfFile = zip.file(/.dbf$/i)[0];
    if (dbfFile) dbfFile.async('arraybuffer').then(result => dbfData = result);
    const prjFile = zip.file(/.prj$/i)[0];
    if (prjFile) prjFile.async('text').then(result => prjString = result);
  });

  // EPSGUser = EPSG4326;
  EPSGUser = proj4(EPSG4326);
  if (prjString) {
    proj4.defs('EPSGUSER', prjString);
    try { EPSGUser = proj4('EPSGUSER'); }
    catch (e) { console.error('Unsuported Projection: ' + e); }
  }
  if (dbfData) dbfString = new TextDecoder().decode(dbfData);

  shpLoader(new SHPParser().parse(shpData, ''), () => {}, proj4);
  dbfLoader(
    new DBFParser().parse(dbfData, '', dbfString, 'utf-16'),
    result => geojson = result,
    proj4
  );
  return geojson;
}

// const zip2shp2geojson = (buffer) => new Promise((resolve, reject) => {
//   // const zip = new JSZip(buffer);
//   // const zip = new JSZip();
//   // zip.load(buffer);
//   // const shpFile = zip.file(/.shp$/i)[0];
//   // console.log(shpFile.name, shpFile);
//   const url = URL.createObjectURL(new Blob([buffer]));
//   return loadshp({ url: url, encoding: 'utf-8' }, geojson => {
//     resolve(geojson);
//   });
// });

// Define a ZIP/SHP format class by subclassing ol/format/GeoJSON:
export class SHP extends GeoJSON {
  constructor(opt_options) { super(opt_options || {}); }

  // needed, it will fail otherwise
  getType() { return 'arraybuffer'; }

  // asyncrously did not work:

  // // readFeature(source, options) {
  // //   zip2shp2geojson(source).then(geojson => {
  // //     return super.readFeature(geojson, options);
  // //   });
  // // }
  // readFeatures(source, options) {
  //   // return new Promise((resolve, reject) => {
  //     zip2shp2geojson(source).then(geojson => {
  //       console.log('unzipped shp as geojson', geojson);
  //       // resolve(super.readFeatures(geojson, options));
  //     });
  //   // });
  // }

  // loaded zip/buffer has to be read synchronously:
  readFeatures(source, options) {
    const geojson = shp2geojson(source);
    return super.readFeatures(geojson, options);
  }
  // readProjection(s) { // s = source
  //   const geojson = (s instanceof ArrayBuffer) ? shp2geojson(s) : s;
  //   return super.readProjection(geojson);
  // }
}
